import { Component, inject, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { MsgType } from 'matrix-js-sdk';
import { HtmlInputDirective } from '../../../directives/sb-client-message-input/html-input.directive';
import { MatIcon } from '@angular/material/icon';
import { UserIconComponent } from '../user-icon/user-icon.component';
import { PinnedMessageDTO, PinnedMessageService } from '../../../services/pinMessages/pinned-message.service';
import { PinnedMessageTestIds } from './sb-pinned-message.test-ids';

@Component({
  selector: 'app-sb-pinned-message',
  imports: [MatTooltip, HtmlInputDirective, MatIcon, UserIconComponent],
  templateUrl: './sb-pinned-message.component.html',
  styleUrl: './sb-pinned-message.component.scss'
})
/**
 * Diese Komponente dient zur Anzeige von angepinnten Nachrichten innerhalb
 * der Raum-Sidebar
 *
 * Funktionen:
 * - Anzeige einer angepinnten Nachricht.
 * - Entpinnen der Nachricht
 *
 * Keine Afo erfüllt, Begründung:
 * Hier werden nur optische Funktionalitäten gesetzt.
 */
export class SbPinnedMessageComponent {
  protected readonly testIds = PinnedMessageTestIds;
  public message = input<PinnedMessageDTO>();
  protected readonly MsgType = MsgType;
  protected readonly Object = Object;
  protected readonly pinnedMessageService = inject(PinnedMessageService);

  async handleUnpinClick(event: Event, messageId: string): Promise<void> {
    event.stopPropagation();
    await this.pinnedMessageService.unpinMessage(messageId);
  }

  async onKeyDown(event: KeyboardEvent, messageId: string): Promise<void> {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      await this.handleUnpinClick(event, messageId);
    }
  }
}
